import Component from './Component';


export default class Header extends Component {
  load() {
    this.initHeader();
    super.load();
  }

  initHeader() {
    $('#primary-navigation .dropdown > .nav-link').on('click', (e) => {
      const $parent = $(e.currentTarget).parent();
      $('#primary-navigation .dropdown.active').not($parent).removeClass('active');
      $parent.toggleClass('active');
    });

    $('[data-toggle="menu"]').on('click', () => {
      const $slideoutMenu = $('.slideout-menu__wrapper');
      $('body').toggleClass('menu-open');

      if (!$('body').hasClass('menu-open')) {
        $slideoutMenu.on('transitionend', () => {
          $slideoutMenu.removeClass('show').off('transitionend');
        });
      } else {
        $slideoutMenu.toggleClass('show');
      }
    });

    $('.desktop-nav > li > a[href*="#"]:not([href="#"])').on('click', (e) => {
      const target = document.querySelector(`.slideout-menu [data-slug="${e.currentTarget.hash.slice(1)}"]`);
      this.currentElement = e.currentTarget;

      if (target) {
        e.preventDefault();
        $('.slideout-menu__wrapper').addClass('show');
        $('body').addClass('menu-open');
        if (!$(target).hasClass('active')) {
          $(target).find('> .nav-link').click().focus().blur();
        }
      }
    });

    $(document).on('keyup', (e) => {
      if (e.keyCode === 27 && $('body').hasClass('menu-open')) {
        $('body').removeClass('menu-open');

        if (this.currentElement) {
          this.currentElement.focus();
          this.currentElement = null;
        }
      }
    })
  }
}
